var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSugesstionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9561 2H2V22H21.9561V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1963 21.9707C10.479 21.8896 9.63672 21.147 9.63672 20.3911V19.6304H14.3149V20.3911C14.3149 21.147 13.4727 21.8901 12.7554 21.9707C12.4102 22.0098 11.5415 22.0098 11.1963 21.9707Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1313 2C12.3349 2.11377 12.518 2.23535 12.5576 2.48975C12.6738 3.23193 12.475 4.25098 12.561 5.02344C12.4384 5.72363 11.5121 5.72363 11.3896 5.02344C11.4755 4.25098 11.2768 3.23193 11.393 2.48975C11.433 2.23486 11.6157 2.11377 11.8193 2H12.1313Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9574 11.8296V12.1416C21.8436 12.3452 21.722 12.5283 21.4677 12.5684C20.726 12.6846 19.7074 12.4858 18.9349 12.5718C18.2352 12.4492 18.2352 11.5225 18.9349 11.3999C19.7069 11.4858 20.726 11.2871 21.4677 11.4033C21.722 11.4434 21.8436 11.626 21.9574 11.8296Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6938 6.73096C15.7587 6.50098 18.5312 10.8296 16.6342 14.4434C15.996 15.6592 15.0834 15.9634 14.8994 17.5054C14.85 17.916 14.9912 18.2979 14.4414 18.4512L9.44721 18.4341C8.90864 18.2368 9.08344 17.6343 9.00092 17.1641C8.83442 16.2129 8.38325 15.9268 7.8437 15.2407C5.19184 11.8701 7.41596 6.97314 11.6938 6.73096ZM12.3901 9.229C12.1215 8.96045 11.5654 9.06738 11.2255 9.14941C10.6997 9.27637 10.1284 9.62988 9.77094 10.0347C9.41352 10.4395 8.71381 11.6021 9.50873 11.897C10.2617 12.1763 10.309 11.1025 10.747 10.6992C11.2314 10.2534 11.5385 10.3384 12.102 10.2212C12.5405 10.1304 12.708 9.54736 12.3901 9.229Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45258 11.4092H5.08588C5.70795 11.5576 5.68012 12.4697 5.05316 12.5684C4.72016 12.6206 2.76068 12.6245 2.45209 12.562C1.85101 12.4399 1.84809 11.5493 2.45258 11.4092Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30201 4.77718C5.48951 4.76106 5.65552 4.85628 5.79664 4.96516C6.13013 5.22249 7.18335 6.27278 7.4314 6.60579C7.65455 6.90511 7.6858 7.30257 7.3357 7.51741C7.06275 7.68538 6.83619 7.6136 6.59986 7.43733C6.27955 7.19856 5.18091 6.09993 4.94312 5.77962C4.6482 5.38265 4.79029 4.82015 5.30201 4.77718Z",
    fill: "#FF9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5563 4.77741C18.8898 4.75104 19.2067 5.0694 19.1803 5.40144C19.1696 5.53767 19.0895 5.67243 19.0094 5.77985C18.7716 6.10017 17.673 7.1988 17.3527 7.43757C17.1168 7.61384 16.8898 7.68513 16.6168 7.51765C16.2672 7.3028 16.298 6.90534 16.5211 6.60603C16.7785 6.26081 17.7892 5.25837 18.1354 4.98347C18.2555 4.88825 18.3986 4.79011 18.5563 4.77741Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugesstionIcon);
export default __webpack_public_path__ + "static/media/sugesstion-icon.246404107c37e55941f6e2eeb4096b8b.svg";
export { ForwardRef as ReactComponent };